import { defineMessages } from 'react-intl-next';

export default defineMessages({
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    RatingSubmissionErrorTitle: {
        defaultMessage: 'Unable to save rating',
        description: 'Error message title when a request feedback rating cannot be saved.',
        id: 'cv.feedback.confirm.page.rating.error.title',
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    RatingSubmissionErrorDescription: {
        defaultMessage:
            'We were unable to save your feedback rating. Reload the page and give it another try. If the problem persists please contact your Administrator.',
        description: 'Error message description when a request feedback rating cannot be saved.',
        id: 'cv.feedback.confirm.page.rating.error.description',
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    CommentSubmissionErrorTitle: {
        defaultMessage: 'Unable to save comment',
        description: 'Error message title when a customer feedback comment cannot be saved.',
        id: 'cv.feedback.confirm.page.comment.error.title',
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    CommentSubmissionErrorDescription: {
        defaultMessage:
            'We were unable to save your comment. Reload the page and give it another try. If the problem persists please contact your Administrator.',
        description: 'Error message description when a request feedback comment cannot be saved.',
        id: 'cv.feedback.confirm.page.comment.error.description',
    },
});
